export default "__VITE_ASSET__ec113cfc__"